export const API_GATEWAY_BASE_URL = import.meta.env.VITE_HOST_API;

/**
 * Laravel (and NEW_ENDPOINTS.md) expose JSON under `/api/...`.
 * If `VITE_HOST_API` is origin only (e.g. `https://host`), append `/api`.
 * If it already ends with `/api`, leave unchanged.
 */
export function getResolvedApiBaseUrl(): string {
    const raw = String(API_GATEWAY_BASE_URL ?? '').trim();
    if (!raw) return '';
    const noTrailing = raw.replace(/\/+$/, '');
    if (noTrailing.endsWith('/api')) return noTrailing;
    return `${noTrailing}/api`;
}
